"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var signals_1 = require("@preact/signals");
var api = __importStar(require("../api"));
var translations_1 = __importStar(require("../common/translations"));
var processing_results_1 = __importDefault(require("./components/processing-results"));
var tracking_1 = require("../common/tracking");
var photo_canvas_1 = __importDefault(require("./components/photo-canvas"));
var compliance_results_1 = __importDefault(require("./components/compliance-results"));
var landing_1 = require("./landing");
var session_params_1 = require("../common/session-params");
var sticky_file_picker_1 = __importDefault(require("./components/sticky-file-picker"));
var hooks_1 = require("preact/hooks");
var session_1 = require("../common/session");
var brand_image_picker_1 = __importDefault(require("./brand-image-picker"));
var pickers_1 = require("./pickers");
var ab_testing_1 = require("../common/ab-testing");
var reorder_checkout_1 = require("./components/reorder-checkout");
try {
    (0, ab_testing_1.cleanUpTests)();
}
catch (err) {
    console.error(err);
}
function getPreviewUrl() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetch("".concat(api.BASE_URL, "/api/upload_url"), {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(__assign({}, (0, session_params_1.getSessionParams)()))
                }).then(function (res) { return res.ok ? res : Promise.reject(new Error('File not found')); }).then(function (res) { return res.json(); })];
        });
    });
}
function getPreview(uuid, promoCode) {
    return __awaiter(this, void 0, void 0, function () {
        var search;
        return __generator(this, function (_a) {
            search = new URLSearchParams(promoCode ? { promoCode: promoCode } : {});
            return [2 /*return*/, fetch("".concat(api.BASE_URL, "/api/preview/").concat(uuid, "?").concat(search)).then(function (res) { return res.json(); })];
        });
    });
}
function proceedToCheckout(data) {
    return __awaiter(this, void 0, void 0, function () {
        var checkoutData, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    checkoutData = __assign({ language: translations_1.i18n.language.split("-")[0], cancelUrl: location.pathname + location.search }, data);
                    return [4 /*yield*/, fetch("".concat(api.BASE_URL, "/api/order"), {
                            method: 'POST',
                            headers: {
                                'content-type': 'application/json'
                            },
                            body: JSON.stringify(checkoutData)
                        }).then(function (res) { return res.json(); })];
                case 1:
                    result = _a.sent();
                    (0, tracking_1.trackEvent)('checkout_started', {
                        ecommerce: {
                            transaction_id: result.order_uuid,
                            currency: 'EUR',
                            value: 8.99,
                            items: [{
                                    item_name: 'Biometric photo'
                                }]
                        }
                    });
                    setTimeout(function () {
                        location.href = result.checkout_url;
                    }, 500);
                    return [2 /*return*/];
            }
        });
    });
}
// 50kb min file size
var MIN_FILE_SIZE_BYTES = 50 * 1000;
var ImagePicker = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var excludeFree = _a.excludeFree;
    var params = new URLSearchParams(location.search);
    var isLoading = (0, signals_1.useSignal)(false);
    var isCheckoutLoading = (0, signals_1.useSignal)(false);
    var isError = (0, signals_1.useSignal)(undefined);
    var reorderToken = (0, signals_1.useSignal)((_b = params.get('reordert')) !== null && _b !== void 0 ? _b : undefined);
    var state = {
        selectedFile: (0, signals_1.useSignal)(undefined),
        docType: (0, signals_1.useSignal)(params.get('doc') || "id-card"),
        country: (0, signals_1.useSignal)(params.get('country') || "de"),
        promoCode: (0, signals_1.useSignal)((_c = params.get('code')) !== null && _c !== void 0 ? _c : undefined)
    };
    var previewState = (0, signals_1.useSignal)(undefined);
    var complianceState = (0, signals_1.useSignal)(undefined);
    var canvasRef = (0, hooks_1.useRef)(null);
    (0, signals_1.useSignalEffect)(function () {
        if (!params.get('country')) {
            fetch("".concat(api.BASE_URL, "/api/country"))
                .then(function (res) { return res.ok ? res.json() : undefined; })
                .then(function (result) {
                if (result === null || result === void 0 ? void 0 : result.country) {
                    state.country.value = result.country;
                }
            })
                .catch(function () { return undefined; });
        }
    });
    (0, signals_1.useSignalEffect)(function () {
        if (isError.value) {
            setTimeout(function () {
                isError.value = undefined;
            }, 5000);
        }
    });
    (0, signals_1.useSignalEffect)(function () {
        var uuid = params.get('preview_uuid');
        if (uuid) {
            isLoading.value = true;
            getPreview(uuid, state.promoCode.value).then(function (result) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    (0, signals_1.batch)(function () {
                        isLoading.value = false;
                        state.country = result.country;
                        state.docType = result.doc;
                        previewState.value = {
                            previewUuid: uuid,
                            fileUuid: result.file_uuid,
                            singleWatermark: result.images.result_watermark,
                            freeUrl: result.images.result,
                            originalUrl: result.images.original,
                            previewUrl: result.images.preview,
                            products: result.products,
                            docType: result.doc,
                            country: result.country
                        };
                        complianceState.value = result.compliance;
                    });
                    return [2 /*return*/];
                });
            }); }).catch(function () {
                (0, signals_1.batch)(function () {
                    isLoading.value = false;
                    isError.value = (0, translations_1.default)("processingError");
                    complianceState.value = {
                        success: false,
                        compliant: false,
                        checks: {
                            technical_error: {
                                key: 'technical_error',
                                compliant: false
                            }
                        }
                    };
                });
            });
        }
    });
    (0, signals_1.useSignalEffect)(function () {
        var _a, _b;
        if ((_a = previewState.value) === null || _a === void 0 ? void 0 : _a.previewUuid) {
            var newParams = new URLSearchParams(params);
            newParams.set("preview_uuid", (_b = previewState.value) === null || _b === void 0 ? void 0 : _b.previewUuid);
            newParams.set("country", state.country.value);
            newParams.set("doc", state.docType.value);
            var newUrl = location.pathname + '?' + newParams.toString();
            history.replaceState({}, "", newUrl);
        }
    });
    (0, signals_1.useSignalEffect)(function () {
        var _a, _b, _c;
        var docChanged = ((_a = previewState.value) === null || _a === void 0 ? void 0 : _a.docType) !== state.docType.value;
        var countryChanged = ((_b = previewState.value) === null || _b === void 0 ? void 0 : _b.country) !== state.country.value;
        var requirementsChanged = docChanged || countryChanged;
        var preview = previewState.peek();
        if (!!preview && requirementsChanged) {
            if (state.selectedFile.value) {
                // Have the original, repeat the process
                handleFileSelected(state.selectedFile.value, { reuseFileUploadUuid: (_c = previewState.value) === null || _c === void 0 ? void 0 : _c.fileUuid });
            }
            else {
                fetch(preview.originalUrl).then(function (res) { return res.blob(); }).then(function (blob) {
                    var _a;
                    var originalFile = new File([blob], 'original.jpg', {
                        type: 'image/jpeg'
                    });
                    handleFileSelected(originalFile, { reuseFileUploadUuid: (_a = previewState.value) === null || _a === void 0 ? void 0 : _a.fileUuid });
                });
            }
        }
    });
    var handleFileSelected = function (file, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.source, source = _c === void 0 ? "native" : _c, reuseFileUploadUuid = _b.reuseFileUploadUuid;
        return __awaiter(void 0, void 0, void 0, function () {
            var newParams, newUrl, fileUuid, result, landingCountry, strictMode, previewInputData_1, _d, images_1, compliance_1, products_1, previewUuid_1, existingFileUuid_1, err_1;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        (0, tracking_1.trackEvent)('preview_requested');
                        // Start loading
                        isLoading.value = true;
                        newParams = new URLSearchParams(params);
                        newParams.delete("preview_uuid");
                        newParams.delete("country");
                        newParams.delete("doc");
                        newUrl = location.pathname + '?' + newParams.toString();
                        history.replaceState({}, "", newUrl);
                        // Reset most of the state
                        (0, signals_1.batch)(function () {
                            state.selectedFile.value = file;
                            complianceState.value = undefined;
                            previewState.value = undefined;
                        });
                        if (file.size < MIN_FILE_SIZE_BYTES) {
                            (0, signals_1.batch)(function () {
                                isError.value = (0, translations_1.default)("smallImageError");
                                complianceState.value = {
                                    success: false,
                                    compliant: false,
                                    checks: {
                                        sufficient_quality: {
                                            key: 'sufficient_quality',
                                            compliant: false
                                        }
                                    }
                                };
                                isLoading.value = false;
                            });
                            return [2 /*return*/];
                        }
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 8, , 9]);
                        fileUuid = undefined;
                        if (!reuseFileUploadUuid) return [3 /*break*/, 2];
                        fileUuid = reuseFileUploadUuid;
                        return [3 /*break*/, 5];
                    case 2: return [4 /*yield*/, getPreviewUrl()];
                    case 3:
                        result = _e.sent();
                        return [4 /*yield*/, fetch(result.url, {
                                method: 'PUT',
                                body: file
                            })];
                    case 4:
                        _e.sent();
                        fileUuid = result.uuid;
                        _e.label = 5;
                    case 5: return [4 /*yield*/, (0, landing_1.getLandingCountry)()];
                    case 6:
                        landingCountry = _e.sent();
                        strictMode = reorderToken.value ? 'true' : 'false';
                        previewInputData_1 = {
                            country: state.country.value,
                            landingCountry: landingCountry,
                            doc: state.docType.value,
                            file_uuid: fileUuid,
                            promoCode: state.promoCode.value,
                            source: source,
                            sessionId: (0, session_1.getSessionId)(),
                            strictMode: strictMode,
                        };
                        return [4 /*yield*/, fetch("".concat(api.BASE_URL, "/api/preview"), {
                                method: 'POST',
                                headers: {
                                    'content-type': 'application/json'
                                },
                                body: JSON.stringify(previewInputData_1)
                            }).then(function (res) { return res.json(); })];
                    case 7:
                        _d = _e.sent(), images_1 = _d.images, compliance_1 = _d.compliance, products_1 = _d.products, previewUuid_1 = _d.uuid, existingFileUuid_1 = _d.file_uuid;
                        (0, signals_1.batch)(function () {
                            if (images_1 !== undefined) {
                                (0, tracking_1.trackEvent)("preview_generated", {
                                    doc_type: previewInputData_1.doc,
                                    country: previewInputData_1.country
                                });
                                previewState.value = {
                                    previewUuid: previewUuid_1,
                                    fileUuid: existingFileUuid_1,
                                    previewUrl: images_1.preview,
                                    singleWatermark: images_1.result_watermark,
                                    freeUrl: images_1.result,
                                    originalUrl: URL.createObjectURL(file),
                                    products: products_1,
                                    docType: previewInputData_1.doc,
                                    country: previewInputData_1.country
                                };
                            }
                            complianceState.value = compliance_1;
                            isLoading.value = false;
                        });
                        return [3 /*break*/, 9];
                    case 8:
                        err_1 = _e.sent();
                        (0, signals_1.batch)(function () {
                            isLoading.value = false;
                            isError.value = (0, translations_1.default)("processingError");
                            complianceState.value = {
                                success: false,
                                compliant: false,
                                checks: {
                                    technical_error: {
                                        key: 'technical_error',
                                        compliant: false
                                    }
                                }
                            };
                        });
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    var handleCheckout = function (_a) {
        var _b, _c, _d;
        var isSubscribed = _a.isSubscribed, withShipping = _a.withShipping, additionalCopies = _a.additionalCopies;
        if (previewState.value && "previewUuid" in previewState.value && !!previewState.value.previewUuid) {
            isCheckoutLoading.value = true;
            var storageGclid = void 0;
            try {
                storageGclid = (_b = localStorage.getItem('psc_gclid')) !== null && _b !== void 0 ? _b : undefined;
            }
            catch (e) { }
            var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            proceedToCheckout({
                country: state.country.value,
                doc: state.docType.value,
                preview_uuid: previewState.value.previewUuid,
                isSubscribed: isSubscribed,
                withShipping: withShipping,
                additionalCopies: additionalCopies !== null && additionalCopies !== void 0 ? additionalCopies : 0,
                promoCode: state.promoCode.value,
                gclid: (_d = (_c = params.get('gclid')) !== null && _c !== void 0 ? _c : storageGclid) !== null && _d !== void 0 ? _d : undefined,
                timezone: timezone
            });
        }
    };
    var handleReorder = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    (0, tracking_1.trackEvent)('reorder_started');
                    isCheckoutLoading.value = true;
                    return [4 /*yield*/, fetch("".concat(api.BASE_URL, "/api/order/reorder"), {
                            method: 'POST',
                            headers: {
                                'content-type': 'application/json'
                            },
                            body: JSON.stringify({
                                reorderToken: reorderToken.value,
                                previewUuid: (_a = previewState.value) === null || _a === void 0 ? void 0 : _a.previewUuid,
                            })
                        }).then(function (res) { return res.json(); })];
                case 1:
                    result = _b.sent();
                    setTimeout(function () {
                        var language = location.pathname.split("/")[1];
                        location.href = "".concat(location.origin, "/").concat(language, "/order-status/?order=").concat(result.order_uuid);
                    }, 500);
                    return [2 /*return*/];
            }
        });
    }); };
    var originalImage = state.selectedFile.value ? URL.createObjectURL(state.selectedFile.value) : undefined;
    var canvasColor = 'white';
    if (((_d = complianceState === null || complianceState === void 0 ? void 0 : complianceState.value) === null || _d === void 0 ? void 0 : _d.compliant) === true) {
        canvasColor = 'green';
    }
    else if (((_e = complianceState === null || complianceState === void 0 ? void 0 : complianceState.value) === null || _e === void 0 ? void 0 : _e.compliant) === false && ((_f = complianceState === null || complianceState === void 0 ? void 0 : complianceState.value) === null || _f === void 0 ? void 0 : _f.success) === true) {
        canvasColor = 'yellow';
    }
    else if (!!(complianceState === null || complianceState === void 0 ? void 0 : complianceState.value)) {
        canvasColor = 'red';
    }
    var processingDone = !!previewState.value || !!(complianceState === null || complianceState === void 0 ? void 0 : complianceState.value);
    var isFreeProduct = (_g = previewState.value) === null || _g === void 0 ? void 0 : _g.products.every(function (p) { return p.type === "free"; });
    if (!processingDone) {
        return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(brand_image_picker_1.default, { country: state.country, docType: state.docType, loading: isLoading, excludeFree: excludeFree, onChange: function (country, doc, file) { return handleFileSelected(file, { source: "native" }); }, canvasRef: canvasRef }), !previewState.value && (0, jsx_runtime_1.jsx)(sticky_file_picker_1.default, { loading: isLoading.value, onChange: handleFileSelected, canvasRef: canvasRef })] });
    }
    else {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ class: "flex flex-col min-h-[calc(100vh-80px)] justify-between" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ class: "bg-white-darker p-2 text-black flex flex-col gap-8 items-center" }, { children: [(0, jsx_runtime_1.jsx)("h1", __assign({ class: "px-2 text-3xl font-bold mt-6" }, { children: (0, translations_1.default)("title") })), (0, jsx_runtime_1.jsx)("h2", __assign({ class: "max-w-lg px-2 text-justify text-base" }, { children: (0, translations_1.default)("subtitle") }))] })), (0, jsx_runtime_1.jsxs)("div", __assign({ class: "bg-white-darker flex flex-col md:flex-row gap-12 md:gap-8 md:items-start items-center justify-center py-8 px-4" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ class: "flex flex-col gap-4 items-center justify-center max-w-md flex-1" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ class: "flex flex-row gap-4 sm:gap-6 md:min-h-[3rem] w-full" }, { children: [(0, jsx_runtime_1.jsx)(pickers_1.CountryPicker, { country: state.country }), (0, jsx_runtime_1.jsx)(pickers_1.DocumentPicker, { country: state.country, docType: state.docType, excludeFree: excludeFree })] })), (0, jsx_runtime_1.jsx)(photo_canvas_1.default, { canvasRef: canvasRef, onChange: function (file) { return handleFileSelected(file, { source: "native" }); }, loading: isLoading.value, originalImage: originalImage !== null && originalImage !== void 0 ? originalImage : (_h = previewState.value) === null || _h === void 0 ? void 0 : _h.originalUrl, previewImage: ((_j = previewState.value) === null || _j === void 0 ? void 0 : _j.singleWatermark) || ((_k = previewState.value) === null || _k === void 0 ? void 0 : _k.freeUrl), color: canvasColor }), !!complianceState.value && (0, jsx_runtime_1.jsx)(compliance_results_1.default, { onChange: handleFileSelected, summary: complianceState.value, isFreeProduct: isFreeProduct }, complianceState.value)] })), !!previewState.value && !!previewState.value.products.length && ((0, jsx_runtime_1.jsx)("div", __assign({ id: "section-plans", class: "flex-1 max-w-md w-full" }, { children: !reorderToken.value ? ((0, jsx_runtime_1.jsx)(processing_results_1.default, { loading: isCheckoutLoading.value, products: previewState.value.products, compliant: !!((_l = complianceState.value) === null || _l === void 0 ? void 0 : _l.compliant), country: state.country.value, docType: state.docType.value, onCheckout: handleCheckout })) : ((0, jsx_runtime_1.jsx)(reorder_checkout_1.ReorderCheckout, { loading: isCheckoutLoading.value, compliant: !!((_m = complianceState.value) === null || _m === void 0 ? void 0 : _m.compliant), onCheckout: handleReorder })) })))] })), !previewState.value && (0, jsx_runtime_1.jsx)(sticky_file_picker_1.default, { loading: isLoading.value, onChange: handleFileSelected, canvasRef: canvasRef })] })) });
    }
};
exports.default = ImagePicker;
